export const GET_CAR_MODELS_REQUEST = "GET_MODELS_REQUEST";
export const GET_CAR_MODELS_SUCCESS = "GET_MODELS_SUCCESS";

export const SHOW_CAR_MODEL_REQUEST = "SHOW_MODEL_REQUEST";
export const SHOW_CAR_MODEL_SUCCESS = "SHOW_MODEL_SUCCESS";

export const SHOW_CAR_MODELS_REQUEST = "SHOW_MODELS_REQUEST";
export const SHOW_CAR_MODELS_SUCCESS = "SHOW_MODELS_SUCCESS";

export const POST_CAR_MODEL_REQUEST = "POST_MODEL_REQUEST";
export const POST_CAR_MODEL_SUCCESS = "POST_MODEL_SUCCESS";

export const PUT_CAR_MODEL_REQUEST = "PUT_MODEL_REQUEST";
export const PUT_CAR_MODEL_SUCCESS = "PUT_MODEL_SUCCESS";

export const DELETE_CAR_MODEL_REQUEST = "DELETE_MODEL_REQUEST";
export const DELETE_CAR_MODEL_SUCCESS = "DELETE_MODEL_SUCCESS";

export const RESET_CAR_MODELS = "RESET_CAR_MODELS";
